import React from "react";

const ResultTag = ({match})=>{
    const matchTag = match?.hasFinish ? 'tag-finished' : 'tag-live'
    const result = match?.resultado?.split('-')
    const localScore = result?.[0];
    const visitorScore= result?.[1]
    return(
                <div className="match-card-result-info">
                <div className={`match-card-time-text ${matchTag}`}>
                    <p>{match?.tiempo}</p>
                </div>
                <div className="match-card-result-container">
                <div className="match-card-resul">{localScore}</div>
                <div className="divider-result-line">
                    <div className="divive-line down-line"></div>
                    <div className="divive-line up-line"></div>
                </div>
                <div className="match-card-resul" >{visitorScore}</div>
                </div>
                {
                    match?.penales && (
                <div className="match-card-result-penalty">
                    <p> Penales: {match?.penales}</p>
                </div>

                    )
                }


            </div>
    )
}

export default ResultTag